import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import { renderForm, renderFormById } from "../../../actions/vipReportActions";
import Spinner from "../../common/Spinner";
import queryString from "query-string";
import TextFieldGroup from "../../common/TextFieldGroup";
import TextAreaFieldGroup from "../../common/TextAreaFieldGroup";
import RadioGroup from "../../common/RadioGroup";
import FileGroup from "../../common/FileGroup";
import { createWebReport } from "../../../actions/vipReportActions";
import isEmpty from "../../../validation/is-empty";
import MobileInputGroup from "../../common/MobileInputGroup";
import classnames from "classnames";
import ReCAPTCHA from "react-google-recaptcha-enterprise";
ReactModal.setAppElement("#root");

class VipReportQuestion extends Component {
  constructor(props) {
    //console.log("VipReportQuestion", props);
    super(props);
    this.state = {
      server_id: "",
      server_name: "",
      in_game_id: "",
      character_name: "",
      email: "",
      phone: "",
      partner_uid: "",
      question_type: "",
      content: "",
      errors: "",
      file01: "",
      mobile_locale: "886",
      captcha_token: "",

      attachments: [],
      loading: false,
      showModal: false,
      token: "",
      useRecaptcha: true,

      flag: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onClick = this.onClick.bind(this);

    this.verifyCallback = this.verifyCallback.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });

    this.props.history.push(
      `/vipservice/${this.props.match.params.game_id}/view/${
        this.props.vipReport.create_result.question_id
      }?token=${
        isEmpty(this.props.vipReport.settings.user)
          ? this.props.vipReport.create_result.token
          : this.state.token
      }`
    );
  }

  onSubmit(e) {
    e.preventDefault();
    const { user, game } = this.props.vipReport.settings;
    let formData = new FormData();
    let fileArray = this.state.attachments;
    for (let index = 1; index <= fileArray.length; index++) {
      formData.append(`attachment${index}`, fileArray[index - 1]);
    }

    if (user) {
      formData.append("partner_uid", user.partner_uid);
      formData.append("server_id", user.server_info.server_id);
      formData.append("in_game_id", user.in_game_id);
      formData.append("character_name", user.character_name);
      formData.append("role_id", user.role_id);
      formData.append("note", user.q_note);
      formData.append("is_in_game", 1);

    } else {
      formData.append("partner_uid", this.state.partner_uid);
      formData.append("server_id", this.state.server_id);
      formData.append("in_game_id", this.state.in_game_id);
      formData.append("character_name", this.state.character_name);
      formData.append("is_in_game", 0);
    }

    formData.append("mobile_locale", this.state.mobile_locale);
    formData.append("phone", this.state.phone);
    formData.append("email", this.state.email);
    formData.append("game_id", game.game_id);
    formData.append("game_name", game.game_name);
    formData.append("question_type", this.state.question_type);
    formData.append("content", this.state.content);
    formData.append("captcha_token", this.state.captcha_token);
    formData.append("useRecaptcha", this.state.useRecaptcha);
    
    //console.log("formData", formData);

    this.props.createWebReport(formData, this.props.history);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
    //console.log(e.target.name, e.target.value);
    //console.log(e.target.files);

    if (!isEmpty(e.target.files)) {
      if (Object.keys(e.target.files).length > 6) {
        this.setState({
          file01: "",
          errors: { file01: "請勿選取超過6個檔案" },
          attachments: [],
        });
      } else {
        this.setState({ errors: {}, attachments: e.target.files });
      }
    }
  }

  onClick(e) {
    e.preventDefault();
    const { game } = this.props.vipReport.settings;
    let formData = new FormData();
    formData.append("in_game_id", this.state.in_game_id);
    formData.append("game_id", game.game_id);
    this.props.renderFormById(formData, this.props.history);
    this.setState({ flag: true });
  }

  verifyCallback(recaptchaToken) {
    this.setState({ captcha_token: recaptchaToken });
  }

  componentDidMount() {
    const search_values = queryString.parse(this.props.location.search);
    
    this.setState({ token: search_values.token });
    document.title = "龍邑遊戲|快速回報【專屬玩家】";

    this.props.renderForm(this.props.match.params.game_id, search_values.token);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.vipReport !== prevProps.vipReport) {
      
      const { game, vip_data } = this.props.vipReport.settings;
      if ((vip_data) && vip_data !== prevProps.vipReport.settings.vip_data) {
        //console.log("vip_data", vip_data);
        let server_name="";
        if (game.servers) {
          game.servers.forEach(
            function(server){
              if (server.server_id === vip_data.server_id)
              server_name = server.server_name;
            }
          )
        }

        this.setState({ email: vip_data.email, phone: vip_data.mobile, mobile_locale: vip_data.mobile_locale, 
          character_name: vip_data.character_name, partner_uid: vip_data.partner_uid, server_id: vip_data.server_id, server_name: server_name });
      }

      if (this.props.vipReport.create_result.question_id) {
        this.handleOpenModal();
      } else {
        this.setState({ showModal: false });
      }
    } 

    if (this.props.errors !== prevProps.errors) {
      this.setState({ errors: this.props.errors });
    }
  }

  render() {
    const {
      game,
      question_types,
      user,
      vip_ranking
    } = this.props.vipReport.settings;
    
    const { loading } = this.props.vipReport;
    const { question_id, check_id } = this.props.vipReport.create_result;

    const {
      errors,
      attachments,
      mobile_locale,
      token,
      useRecaptcha,
    } = this.state;

    if (errors.msg) {
      this.props.history.push("/support");
    }
    
    if (user && !vip_ranking) {
      this.props.history.push(`./service_quick?param_game_id=${this.props.match.params.game_id}`);
    }

    const localeOptions = [
      { label: "台灣 (+886)", value: "886", placeholder: "0912 345 678" },
      { label: "香港 (+852)", value: "852", placeholder: "5123 4567" },
      { label: "澳門 (+853)", value: "853", placeholder: "6612 3456" },
      { label: "新加坡 (+65)", value: "65", placeholder: "8123 4567" },
      { label: "馬來西亞 (+60)", value: "60", placeholder: "12 345 6789" },
    ];

    const phone_placeholder = localeOptions.filter(
      (local) => local.value === mobile_locale
    )[0].placeholder;

    const fileInfo = Object.keys(attachments).map(
      (attach) => attachments[attach].name
    );
    const home_link = !isEmpty(user)
      ? `/vipservice?token=${token}`
      : `/vipservice?param_game_id=${this.props.match.params.game_id}`;

    let typesOption = [];
    let formContent;
    let game_title;

    if (game && question_types) {
      
      typesOption = Object.getOwnPropertyNames(question_types).map((type) => ({
        label: question_types[type],
        value: type,
      }));

      if (game.game_name) {
        game_title = game.game_name;
      }

      if (user) {
        formContent = (
          <div>
            <div class="card"><div class="card-body">
            <div className="form-group">
              <label className="text-primary">
                <strong>伺服器：{user.server_info.server_name}</strong>
              </label>
              
            </div>

            <div className="form-group">
              <label className="text-primary">
                <strong>角色名稱：{user.character_name}</strong>
              </label>
              
            </div>
            </div></div><br />

            <TextFieldGroup
              placeholder="* Email"
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.onChange}
              error={errors.email}
              info="我們將會使用email通知回報後續處理結果, 請務必正確填寫"
            />

            <MobileInputGroup
              placeholder={phone_placeholder}
              name="phone"
              type="tel"
              locale_value={this.state.mobile_locale}
              localeOptions={localeOptions}
              value={this.state.phone}
              onChange={this.onChange}
              error={errors.phone}
              info="格式為純數字, 不需任何符號"
            />
          </div>
        );
      } else {
        formContent = (
          <div>
            <div class="card"><div class="card-body">
            <div className="input-group">
            <input
              type="text"
              className={classnames("form-control form-control-md", {
                "is-invalid": errors.in_game_id
              })}
              placeholder="* 角色ID"
              name="in_game_id"
              value={this.state.in_game_id}
              onChange={this.onChange}
              
            />
            <button
              onClick={this.onClick}
              className="btn btn-primary"
            >
              確認ID
            </button>            
            {errors.in_game_id && <div className="invalid-feedback">{errors.in_game_id}</div>}
            </div>
            <small className="form-text text-muted">請輸入角色ID</small>
            
            <br />
            {this.state.flag && !vip_ranking && (
              <span className='alert alert-danger'>
                很抱歉，此功能未開放所有玩家使用。
              </span>
            )}
            <hr />
            <div className="form-group">
              <label className="text-primary">
                <strong>伺服器：{this.state.server_name}</strong>
              </label>
              
            </div>
            
            <div className="form-group">
              <label className="text-primary">
                <strong>角色名稱：{this.state.character_name}</strong>
              </label>
              
            </div>
            </div></div><br />
            <TextFieldGroup
              placeholder="* Email"
              name="email"
              type="email"
              value={this.state.email?this.state.email:""}
              onChange={this.onChange}
              error={errors.email}
              info="我們將會使用email通知回報後續處理結果, 請務必正確填寫"
            />
            <MobileInputGroup
              placeholder={phone_placeholder}
              name="phone"
              type="tel"
              locale_value={this.state.mobile_locale}
              localeOptions={localeOptions}
              value={this.state.phone?this.state.phone:""}
              onChange={this.onChange}
              error={errors.phone}
              info="格式為純數字, 不需任何符號"
            />
          </div>
        );
      }
    }

    return (
      <div className="container" style={{backgroundColor: '#fafbfe' }}>
        <div className="row">
          <div className="col-sm-12 col-md-9 col-lg-6 m-auto">
            <h4 className="text-center mt-5">{game_title} 快速回報【專屬玩家】</h4>
            <hr />

            {loading ? (
              <Spinner />
            ) : (
              <div>
                <form onSubmit={this.onSubmit}>
                  {formContent}
                  <br />
                  <RadioGroup
                    name="question_type"
                    value={this.state.question_type}
                    onChange={this.onChange}
                    error={errors.question_type}
                    options={typesOption}
                    info="問題類型"
                  />
                  
                  <TextAreaFieldGroup
                    placeholder="* 問題描述"
                    name="content"
                    value={this.state.content}
                    onChange={this.onChange}
                    error={errors.content}
                    info="請詳細描述您所遇到的遊戲問題"
                  />

                  <FileGroup
                    name="file01"
                    filename={
                      !isEmpty(fileInfo)
                        ? `已選取${Object.keys(attachments).length}個`
                        : "附件(最多6個)"
                    }
                    onChange={this.onChange}
                    error={errors.file01}
                    limit={6}
                    info={!isEmpty(fileInfo) ? fileInfo : []}
                  />
                  {useRecaptcha && (
                    <ReCAPTCHA
                      sitekey="6Lcyc_UbAAAAACraqz0XIzXBepnOgtAvRgPsLVuD"
                      onChange={this.verifyCallback}
                      size={useRecaptcha ? "normal" : "invisible"}
                    />
                  )}
                  {errors.captcha_token && (
                    <div className="invalid-feedback d-block">
                      {errors.captcha_token}
                    </div>
                  )}

                  <input
                    type="submit"
                    value="送出"
                    className="btn btn-info btn-block"
                    disabled={vip_ranking?false:true}
                  />
                  <Link to={home_link} className="btn btn-secondary btn-block">
                    取消
                  </Link>
                </form>
                <ReactModal
                  isOpen={this.state.showModal}
                  contentLabel=""
                  style={{ overlay: { zIndex: 10 } }}
                >
                  <h3 className="text-center">【專屬玩家】提問結果</h3>
                  <hr />
                  <div className="row">
                    <div className="col-sm-12 col-md-4 m-auto">
                      <div className="alert alert-success">
                        <strong>回報單 #{question_id} 提問成功</strong>
                        {isEmpty(user) && (
                          <div>
                            <br />
                            我們已經傳送郵件到您的mail，
                            <br />
                            後續追蹤客服請用提問mail或手機及以下代碼查詢：
                            <font color="red" face="cursive">
                              <b>{check_id}</b>
                            </font>
                            <br />
                            <font color="red">
                              註:專員將會回覆至<strong>回報紀錄</strong>
                              頁面給您，務必自行前往查看。
                            </font>
                          </div>
                        )}
                      </div>

                      <button
                        onClick={this.handleCloseModal}
                        className="btn btn-primary m-auto"
                      >
                        確認
                      </button>
                    </div>
                  </div>
                </ReactModal>
              </div>
            )}
          </div>
        </div>
        <br /><br /><br />
      </div>
    );
  }
}

VipReportQuestion.propTypes = {
  renderForm: PropTypes.func.isRequired,
  renderFormById: PropTypes.func.isRequired,
  createWebReport: PropTypes.func.isRequired,
  errors: PropTypes.object,
};
const mapStateToProps = (state) => ({
  vipReport: state.vipReport,
  errors: state.errors,
});
export default connect(mapStateToProps, { renderForm, renderFormById, createWebReport })(
  VipReportQuestion
);
